<!-- @format -->

<a
  class="skip-link"
  id="skip-link"
  data-cy="skip-link"
  href="javascript:void(0)"
  (focus)="handleFocus()"
  (blur)="onBlur()"
  (click)="moveToMain()"
  >{{ "SKIP_LINK.MOVE_TO_MAIN_CONTENT" | translate }}</a
>
